import { Card, Skeleton } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { useGetSubscriptionQuery } from '@blockpulse3/graphql/hooks';
import { ErrorQueryCard, Progression, ProgressionStep } from '@blockpulse3/ui/commons';

import { getFundraisingStep } from './utils';

type Props = unknown;

export function SubscriptionProgression(): JSX.Element {
  const i18nSubscribeProgressionBar = useTranslations(
    'SubscriptionInformations.SubscriptionProgression',
  );
  const i18nBadge = useTranslations('Badge');

  const { subscriptionId = '' } = useParams();

  const { data, loading, error } = useGetSubscriptionQuery({
    variables: { subscriptionId },
  });

  if (loading) {
    return (
      <Skeleton>
        <Card h="80px" />
      </Skeleton>
    );
  }

  if (error) {
    return <ErrorQueryCard h="80px" />;
  }

  if (!data) {
    return <ErrorQueryCard h="80px" />;
  }

  const { subscription } = data;

  const fundraising = subscription.fundraising;
  const currentStep = getFundraisingStep(fundraising.status);

  return (
    <Progression boxShadow="none" currentStep={currentStep} totalSteps={3}>
      <ProgressionStep
        isCompleted={currentStep >= 1}
        subTitle={dayjs(fundraising?.startSubscriptionDate).format('D MMMM YYYY')}
        title={i18nSubscribeProgressionBar('FundraisingStart')}
      />
      <ProgressionStep
        isCompleted={currentStep >= 2}
        subTitle={i18nBadge('InProgress')}
        title={i18nSubscribeProgressionBar('ShareholderSubscribe')}
      />
      <ProgressionStep
        isCompleted={currentStep >= 3}
        subTitle={dayjs(fundraising?.endSubscriptionDate).format('D MMMM YYYY')}
        title={i18nSubscribeProgressionBar('FundraisingEnd')}
      />
    </Progression>
  );
}

export type SubscriptionProgressionProps = Props;
